<div
  class="p-8 flex flex-col gap-3 large-mobile:items-start items-center w-full relative"
  [class.animate-current-card]="upgradeStatus().direction === 'current'"
>
  @if (upgradeStatus().direction === 'current') {
    <div class="absolute top-0 right-0 p-4">
      <ion-icon
        name="ribbon-outline"
        class="text-warning-600 text-xl"
      ></ion-icon>
    </div>

    <ion-badge
      class="absolute top-[10px] left-[10px] px-3 py-1 text-[10px] rounded-full animate-pulse-slow bg-gradient-to-r from-warning-500 to-warning-600 text-white shadow-sm shadow-warning-300"
      mode="ios"
    >
      {{ name() + ' Member' | locale }}
    </ion-badge>
  }

  <div
    class="rounded-full shadow-[0px_0px_0px_6px_#fafafa] w-10 h-10 bg-accent-light flex items-center justify-center"
  >
    <ion-icon [name]="icon()" class="text-accent text-2xl" />
  </div>
  <p class="font-sherika-bold text-sm text-accent">{{ name() | locale }}</p>
  <h3 class="text-3xl [&>span]:font-sherika-bold">
    @if (!price()) {
      <span>{{ 'Free' | locale }}</span>
    } @else {
      <span class="flex gap-2 items-end">
        @if (price()) {
          <span class="text-black font-semibold"
            >{{ price() | currency }}<span class="text-sm">/year</span>
          </span>
        }
      </span>
    }
  </h3>
  <div class="w-full flex flex-col gap-4 mt-6">
    @if (upgradeStatus().direction === 'current') {
      <b>{{ 'Your plan benifits' | locale }}</b>
    }
    @for (pro of pros(); track pro) {
      <div class="w-full flex gap-2 items-center">
        <div
          class="rounded-full w-5 h-5 flex items-center justify-center bg-accent-light"
        >
          <ion-icon name="checkmark-outline" class="text-accent" />
        </div>
        <p class="text-sm text-gray-600">{{ pro | locale }}</p>
      </div>
    }
    @if (upgradeStatus().direction !== 'current') {
      @for (con of cons(); track con) {
        <div class="w-full flex gap-2 items-center">
          <div
            class="rounded-full w-5 h-5 flex items-center justify-center bg-gray-100"
          >
            <ion-icon name="close-outline" class="text-gray-500" />
          </div>
          <p class="text-sm text-gray-600">{{ con | locale }}</p>
        </div>
      }
    }
    @if (upgradeStatus().direction === 'current') {
      <i class="text-xs text-gray-500"
        >{{
          (subscriptionService.subscription()?.willRenew
            ? 'Renews on'
            : 'Expires on'
          ) | locale
        }}
        <b class="text-normal">{{ renewsOn() | date: 'longDate' }}</b>
      </i>
    }
  </div>
</div>
<div class="w-full p-8 bg-gray-50 mt-auto">
  @if (upgradeStatus().direction === 'current') {
    @if (upgradeStatus().willRenew) {
      <app-button (click)="cancel()" [outlined]="true" [type]="'dark'">
        @if (processing()) {
          <ion-spinner
            name="crescent"
            class="text-accent"
            mode="ios"
          ></ion-spinner>
        } @else {
          {{ 'Cancel subscription' | locale }}
        }
      </app-button>
    } @else {
      <app-button (click)="renew()" [outlined]="true" [type]="'dark'">
        {{ 'Renew subscription' | locale }}
      </app-button>
    }
  } @else {
    <app-button
      class="w-full"
      [buttonStyleClass]="'w-full'"
      (click)="onUpgradeClick()"
      [outlined]="price() === 0"
      [disabled]="upgradingInProgress()"
      >{{ upgradeStatus().displayText | locale }}
    </app-button>
  }
</div>
